import React, { lazy } from "react";
import {
  createBrowserRouter,
  Navigate,
  redirect,
  RouterProvider,
} from "react-router-dom";
import App from "./App";
import Landing from "./pages/Landing";
import Authenticate from "./pages/Authenticate";
import Toast from "./components/ToastComponent";
import * as constant from "./utils/constants";
import ImageGallery from "./siteManagement/IQTechMax/ImageGallery";
import Dashboard from "./pages/Dashboard";
import Layout from "./components/Layout";

const SuperAdminOrgLayout = lazy(() =>
  import("./siteManagement/IQTechMax/Layout")
);
const SuperAdminDashboard = lazy(() =>
  import("./siteManagement/IQTechMax/Dashboard")
);
const SuperAdminBlog = lazy(() => import("./siteManagement/IQTechMax/Blog"));
const SuperAdminBanner = lazy(() =>
  import("./siteManagement/IQTechMax/Banner")
);
const SuperAdminTestimonial = lazy(() =>
  import("./siteManagement/IQTechMax/Testimonial")
);
const SuperAdminCaseStudies = lazy(() =>
  import("./siteManagement/IQTechMax/CaseStudies")
);

const appRouter = createBrowserRouter([
  {
    path: "/",
    element: <Landing />,
  },
  {
    path: "/*",
    element: (
      <Authenticate
        defaultRedirectPath={constant.APP_ROUTE_DASHBOARD}
        // stopGlobalLoader={stopLoader}
        AppComponent={Layout}
        // AppComponentProps={{ stopGlobalLoader: stopLoader }}
      ></Authenticate>
    ),
    children: [
      {
        path: constant.APP_PATH_DASHBOARD,
        element: <Dashboard />,
      },
      {
        path: constant.APP_PATH_SUPER_ADMIN,
        element: <SuperAdminOrgLayout />,
        children: [
          {
            index: true,
            element: <Navigate to={constant.APP_PATH_DASHBOARD} replace />,
          },
          {
            path: constant.APP_PATH_DASHBOARD,
            element: <SuperAdminDashboard />,
          },
          { path: constant.APP_PATH_BLOG, element: <SuperAdminBlog /> },
          { path: constant.APP_PATH_BANNER, element: <SuperAdminBanner /> },
          {
            path: constant.APP_PATH_TESTIMONIAL,
            element: <SuperAdminTestimonial />,
          },
          {
            path: constant.APP_PATH_CASE_STUDIES,
            element: <SuperAdminCaseStudies />,
          },
          { path: constant.APP_PATH_IMAGE_GALLERY, element: <ImageGallery /> },
        ],
      },
    ],
  },
]);

const Main = () => {
  return (
    <React.StrictMode>
      <Toast />
      <div className="App">
        <RouterProvider router={appRouter} />
      </div>
    </React.StrictMode>
  );
};

export default Main;
